'use client';

import { useCallback } from 'react';
import { notify } from 'src/utils/notifications';
import TransactionErrorHandler from 'src/utils/TransactionErrorHandler/TransactionErrorHandler';
import useDriftClient from 'src/hooks/useDriftClient';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';

/**
 * Hook for withdrawing dust positions
 */
export const useWithdrawDustPositions = () => {
	const driftClient = useDriftClient();
	const walletAdapter = useDriftStore((s) => s.wallet.current.adapter);

	const withdrawDustPositions = useCallback(async () => {
		if (!driftClient || !walletAdapter) return false;

		const toastId = 'withdrawDustPositions';

		try {
			let withdrawCount: number | undefined = undefined;

			const txSig = await driftClient.withdrawAllDustPositions(
				undefined,
				undefined,
				{
					dustPositionCountCallback: (count) => {
						withdrawCount = count;

						if (count === 0) {
							notify({
								id: toastId,
								type: 'error',
								message: 'No dust positions to withdraw.',
							});
							return true;
						}

						notify({
							id: toastId,
							type: 'awaiting_wallet_confirmation',
							showUntilCancelled: true,
						});
					},
				}
			);

			if (txSig) {
				notify({
					id: toastId,
					type: 'success',
					message: `Withdrew ${withdrawCount ?? ''} dust positions.`,
					showUntilCancelled: false,
				});
				return true;
			}
		} catch (e: any) {
			TransactionErrorHandler.handleError({
				error: e,
				toastId,
				wallet: walletAdapter,
			});
			return false;
		}
	}, [driftClient, walletAdapter]);

	return { withdrawDustPositions };
};
